import Environment from "./Environment";



// ============================================================================
// AUTO-GENERATED COMMON PROJECTS
// ============================================================================
// This array is automatically generated from Environment.PROJECTS
// No need to manually update this when adding new presales!

export const COMMON_PROJECTS = Object.entries(Environment?.PROJECTS)
    .filter(([key, config]) => {
        // Filter out projects without presale if needed
        // Currently including all projects
        return key !== "NODEMINER"; // Exclude NODEMINER from common projects
        return true;
    })
    .map(([key, config]) => {
        // Use the latest graph version if multiple versions exist
        const graph = config.graphV3 || config.graphV2 || config.graph;

        return {
            value: key,
            label: config.label,
            imageSrc: config.imageSrc,
            graph: graph,
            rounds:config.rounds,
            ...config
        };
    });
export const COMMON_PROJECTS_Fixed = Object.entries(Environment?.PROJECTS_Fixed)
    .filter(([key, config]) => {
        // Filter out projects without presale if needed
        // Currently including all projects
        return key !== "NODEMINER"; // Exclude NODEMINER from common projects
        return true;
    })
    .map(([key, config]) => {
        // Use the latest graph version if multiple versions exist
        const graph = config.graphV3 || config.graphV2 || config.graph;

        return {
            value: key,
            label: config.label,
            imageSrc: config.imageSrc,
            graph: graph,
        };
    });


// export const COMMON_PROJECTS = [
//     {
//         value: "TIGA",
//         label: "Tiga",
//         imageSrc: "https://gems.vip/assets/alldetailpages/tiga/main-img.png",
//         graph: Environment.TIGAGraph,
//     },
//     {
//         value: "CHAINERS",
//         label: "Chainers",
//         imageSrc: "https://gems.vip/assets/alldetailpages/chainers/main-img.png",
//         graph: Environment.CHAINERSGraph,
//     },
//     {
//         value: "SCREX",
//         label: "Screx",
//         imageSrc: "https://gems.vip/assets/alldetailpages/screx/screxlogo.svg",
//         graph: Environment.SCREXGraph,
//     },
//     {
//         value: "LUCKIFY",
//         label: "Luckify",
//         imageSrc: "/assets/luckify.svg",
//         graph: Environment.LUCKIFYGraph,
//     },
//     {
//         value: "MATCHAIN",
//         label: "Matchain",
//         imageSrc: "/assets/matchain.svg",
//         graph: Environment.MATCHAINGraph,
//     },
//     {
//         value: "RAIN",
//         label: "Rain",
//         imageSrc: "/assets/rain.svg",
//         graph: Environment.RainGraphV3,
//     },
//     {
//         value: "ASTRANOVA",
//         label: "Astra Nova",
//         imageSrc: "/assets/astronova.svg",
//         graph: Environment.AstroNovaGraphV2,
//     },
//     {
//         value: "NFA",
//         label: "NFA",
//         imageSrc: "/assets/nfa.svg",
//         graph: Environment.NFAGraph,
//     },
//     {
//         value: "LEIA",
//         label: "Leia",
//         imageSrc: "/assets/leia.svg",
//         graph: Environment.LEIAGraph,
//     },
//     {
//         value: "OLYMPUS",
//         label: "Olypmus",
//         imageSrc: "/assets/olympus.svg",
//         graph: Environment.OlympusGraph,
//     },
//     {
//         value: "INCENTIV",
//         label: "Incentiv",
//         imageSrc: "/assets/incentiv-new-logo.svg",
//         graph: Environment.Graph,
//     },
//     {
//         value: "GEMS",
//         label: "Gems",
//         imageSrc: "/assets/gems.svg",
//         graph: Environment.GemsGraph,
//     },
// ];


// Dashboard.js / TokenSetting.js
export const PROJECT_MAPPING = [
    ...COMMON_PROJECTS,
    {
        value: "DOP",
        label: "DOP",
        imageSrc: "/assets/dop.svg",
    },
];
export const PROJECT_MAPPING_Fixed = [
    ...COMMON_PROJECTS_Fixed,
    {
        value: "DOP",
        label: "DOP",
        imageSrc: "/assets/dop.svg",
    },
];

export const projectPercentage = {
    DOP: 0.05,
    GEMS: 0.05,
    LEIA: 0.05,
    OLYMPUS: 0.05,
    INCENTIV: 0.05,
    NFA: 0.1,
    ASTRANOVA: 0.1,
    RAIN: 0.1,
    MATCHAIN: 0.1,
    LUCKIFY: 0.1,
    SCREX: 0.1,
  };
// SalesRound
export const PROJECT_ITEMS = [
    // Uncomment if needed
    // {
    //   value: "ALL_PROJECTS",
    //   label: "All Projects",
    //   imageSrc: "",
    // },
    ...COMMON_PROJECTS,
    // DOP intentionally excluded
];

// Claim.js
export const CLAIM_PROJECT_DATA = [
    ...COMMON_PROJECTS,
    {
        value: "DOP",
        label: "DOP",
        imageSrc: "/assets/dop.svg",
    },
];
// Refund flow
export const REFUND_PROJECT_DATA = [
    {
        value: "CHAINERS",
        label: "Chainers",
        imageSrc: "https://gems.vip/assets/alldetailpages/chainers/main-img.png",
    },
    {
        value: "SCREX",
        label: "Screx",
        imageSrc: "https://gems.vip/assets/alldetailpages/screx/screxlogo.svg",
    },
    {
        value: "LUCKIFY",
        label: "Luckify",
        imageSrc: "/assets/luckify.svg",
    },
    {
        value: "MATCHAIN",
        label: "Matchain",
        imageSrc: "/assets/matchain.svg",
    },
    {
        value: "RAIN",
        label: "Rain",
        imageSrc: "/assets/rain.svg",
    },

    {
        value: "NFA",
        label: "NFA",
        imageSrc: "/assets/nfa.svg",
    },
    {
        value: "LEIA",
        label: "Leia",
        imageSrc: "/assets/leia.svg",
    },
    {
        value: "OLYMPUS",
        label: "Olypmus",
        imageSrc: "/assets/olympus.svg",
    },
    {
        value: "INCENTIV",
        label: "Incentiv",
        imageSrc: "/assets/incentiv-new-logo.svg",
    },
    {
        value: "GEMS",
        label: "Gems",
        imageSrc: "/assets/gems.svg",
    },
    {
        value: "DOP",
        label: "DOP",
        imageSrc: "/assets/dop.svg",
    },

    {
        value: "ASTRANOVA",
        label: "Astra Nova",
        imageSrc: "/assets/astronova.svg",
    },

    {
        value: "MINIMINER",
        label: "Mini Miners",
        imageSrc: "/assets/miniminer.svg",
    },
    {
        value: "STANDARDMINER",
        label: "Standard Miners",
        imageSrc: "/assets/standardminer.svg",
    },
    {
        value: "MEGAMINER",
        label: "Mega Miners",
        imageSrc: "/assets/megaminer.svg",
    },
    {
        value: "NODE",
        label: "Node",
        imageSrc: "/assets/node.svg",
    },
];
export const times = ["1 Day", "3 Days", "7 Days", "1 Month", "1 Year"];

export const LEADER_CLAIMS_TOKENS = [
    { symbol: "ETH", decimals: 5 },
    { symbol: "USDT", decimals: 4 },
    { symbol: "DOP", decimals: 4 },
    { symbol: "WBTC", decimals: 4 },
    { symbol: "USDC", decimals: 4 },
    { symbol: "PEPE", decimals: 4 },
    { symbol: "LINK", decimals: 4 },
    { symbol: "UNI", decimals: 4 },
    { symbol: "TOMI", decimals: 4 },
    { symbol: "GEMS", decimals: 4 },
]
export const Claim_Amounts_Config = [
    { symbol: "ETH", key: "amountClaimsEth", decimals: 5 },
    { symbol: "USDT", key: "amountClaimsUsdt", decimals: 2 },
    { symbol: "DOP", key: "amountClaimsDopToken", decimals: 0 },
    { symbol: "WBTC", key: "amountClaimsWbtc", decimals: 5 },
    { symbol: "USDC", key: "amountClaimsUsdc", decimals: 2 },
    { symbol: "PEPE", key: "amountClaimsPepe", decimals: 4 },
    { symbol: "LINK", key: "amountClaimsLink", decimals: 2 },
    { symbol: "UNI", key: "amountClaimsUni", decimals: 2 },
    { symbol: "TOMI", key: "amountClaimsTomi", decimals: 2 },
    { symbol: "GEMS", key: "amountClaimsGems", decimals: 2 },
];
export const claimedRebuyConfig = [
    { symbol: "ETH", key: "totalEth", decimals: 5 },
    { symbol: "USDT", key: "totalUsdt", decimals: 2 },
    { symbol: "DOP", key: "totalDopToken", decimals: 2 },
    { symbol: "WBTC", key: "totalWbtc", decimals: 5 },
    { symbol: "USDC", key: "totalUsdc", decimals: 2 },
    { symbol: "PEPE", key: "totalPepe", decimals: 4 },
    { symbol: "LINK", key: "totalLink", decimals: 4 },
    { symbol: "UNI", key: "totalUni", decimals: 4 },
    { symbol: "TOMI", key: "totalTomi", decimals: 4 },
    { symbol: "GEMS", key: "totalGems", decimals: 4 },
];
export const rebuyConfig = [
    { symbol: "ETH", key: "totalEth", decimals: 5 },
    { symbol: "USDT", key: "totalUsdt", decimals: 4 },
    { symbol: "DOP", key: "totalDopToken", decimals: 2 },
    { symbol: "WBTC", key: "totalWbtc", decimals: 5 },
    { symbol: "USDC", key: "totalUsdc", decimals: 4 },
    { symbol: "PEPE", key: "totalPepe", decimals: 4 },
    { symbol: "LINK", key: "totalLink", decimals: 4 },
    { symbol: "UNI", key: "totalUni", decimals: 4 },
    { symbol: "TOMI", key: "totalTomi", decimals: 4 },
    { symbol: "GEMS", key: "totalGems", decimals: 4 },
];
